module.exports = __webpack_public_path__ + "static/img/right2.07b4d322.png";